export default "__VITE_ASSET__BHnJ$TbW__"